import React, { useState } from 'react';
import { Drawer, Stack, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useApi } from '../context/useApi';
import { useTranslation } from 'react-i18next';
import { IProducts, ProductsFilters } from '../models/interfaces';
import { SearchFnReturn, useBaseList } from '../hook/useBaseList';
import { convertStringsToSort, tranformSearchFiltersForBE } from '../utils/helpers';
import type { AxiosResponse } from 'axios';
import { List } from '../shared/list';
import ProductFilters from '../components/ProductFIlters';
import ProductDetail from '../components/ProductDetail';

const FILTER_STORE_KEY = 'product';
const Products = () => {
  const { state, } = useLocation();
  const { defaultApi } = useApi();
  const { t } = useTranslation();

  const [product, setProduct] = useState<IProducts>();

  const searchFn = async (
    page: number,
    size: number,
    filters: ProductsFilters,
    sort?: string[],
  ): Promise<SearchFnReturn<IProducts>> => {
    filters = tranformSearchFiltersForBE(filters);
    let resp: AxiosResponse<any>;
    filters = { ...filters };
    if (sort && sort.length > 0) {
      resp = await defaultApi.productsSearchPost({
        params: { page: page, size: size, sort },
        data: { ...filters },
      });
    } else {
      resp = await defaultApi.productsSearchPost({
        params: { page: page, size: size },
        data: { ...filters },
      });
    }

    if (resp.status === 200) {
      return { count: resp.data?.data.totalElements ?? 0, list: resp.data.data?.content ?? [] };
    } else {
      throw Error('Errore');
    }
  };

  const defaultFilters: ProductsFilters = {};

  const {
    list,
    page,
    pageSize,
    count,
    isLoading,
    isPreviousData,
    handlePageChange,
    handlePageSizeChange,
    clearFilters,
    sort,
    onSortClick,
    filtersForm: formProps,
  } = useBaseList<IProducts, ProductsFilters>({
    searchFn: searchFn,
    overrideFilters: state?.stateFilters,
    defaultFilters: defaultFilters,
    filterStoreKey: FILTER_STORE_KEY,
    apiOptions: { cacheTime: 20000 },
  });

  const handleClose = () => {
    setProduct(undefined);
  };

  return (
    <>
      <>
        <Stack
          direction="row"
          ml={'20px'}
          alignItems={'center'}
          justifyContent="space-between"
          spacing={1}
          marginBottom={2}
        >
          <Stack direction={'row'} alignItems={'center'} spacing={4} height={'56px'}>
            <Typography variant="h4" color="inherit">
              {t('product.title')}
            </Typography>
          </Stack>
        </Stack>
        <ProductFilters
          clearFilters={clearFilters}
          formProps={formProps}
          defaultFilters={defaultFilters}
        />
        <List
          maxheight="calc(100vh - 20px)"
          list={list}
          count={count}
          page={page}
          pageSize={pageSize}
          loading={isLoading}
          isPreviousData={isPreviousData}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          gridTemplateColumns={'1.7fr 1.7fr 1fr 1fr 2fr 1fr 0.7fr 0.8fr'}
          keyGetter={(e: any) => e.id as string}
          sortBy={convertStringsToSort(sort)}
          onSortClick={onSortClick}
          onItemClick={(e: IProducts) => {
            // createDialog({ children: <ProductDetail product={e} />, open: true, maxWidth: 'lg' });
            setProduct(e);
          }}
          fields={[
            {
              title: t('product.clusterId'),
              key: 'cluster_id',
              sortable: false,
            },
            {
              title: t('product.productId'),
              key: 'id_prodotto',
              sortable: false,
               tooltip: true,
            },
            {
              title: t('product.supplierCode'),
              key: 'codice_fornitore',
              sortable: false,
            },
            {
              title: t('product.manufacturerRef'),
              key: 'ref_produttore',
              sortable: false,
              tooltip: true,
            },
            {
              title: t('product.productName'),
              key: 'nome_prodotto',
              sortable: false,
              tooltip: true,
            },
            {
              title: t('product.supplierName'),
              key: 'nome_fornitore',
              sortable: false,
            },
            {
              title: t('product.managementId'),
              key: 'id_gestionale',
              sortable: false,
            },
            {
              title: t('product.structureId'),
              key: 'id_struttura',
              sortable: false,
            },
            // {
            //   title: t('product.manuallyMatched'),
            //   key: 'manual_matched',
            //   sortable: false,
            //   cellRenderer: (e: IProducts) => {
            //     return (
            //       <IconButton color="primary">{e.manual_matched ? <Done /> : <Close />}</IconButton>
            //     );
            //   },
            // },
            // {
            //   title: t('product.vatNumber'),
            //   key: 'p_iva',
            //   sortable: false,
            // },
            // {
            //   title: t('product.unitPrice'),
            //   key: 'prezzo_unitario',
            //   sortable: false,
            // },
            // {
            //   title: t('product.rdm'),
            //   key: 'rdm',
            //   sortable: false,
            // },
            // {
            //   title: t('product.cnd'),
            //   key: 'cnd',
            //   sortable: false,
            // },
            // {
            //   title: t('product.toReview'),
            //   key: 'to_review',
            //   cellRenderer: (e) => {
            //     return <IconButton color="primary">{e.to_review ? <Done /> : <Close />}</IconButton>;
            //   },
            // },
          ]}
          emptyListMessage={t('info.noResult')}
          keepRecentlyOpenedItem
          // lastOpenedItem={lastOpenedItem}
        />
      </>
      <Drawer
        SlideProps={{ timeout: 500 }}
        keepMounted={false}
        anchor="right"
        open={product !== undefined}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: { xs: '90%'}, // larghezza responsive
            maxWidth: '100%', // non oltre lo schermo
          },
        }}
      >
        {product && <ProductDetail product={product} />}
      </Drawer>
    </>
  );
};

export default Products;
